import React from 'react';
import oneAppModuleWrapper from '@americanexpress/one-app-module-wrapper';
import { IntlProvider } from 'react-intl';
import { loadLanguagePack } from '@americanexpress/one-app-ducks';
import { composeModules, RenderModule } from 'holocron';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { ProgressCircular, Surface } from '@americanexpress/dls-react';
import childRoutes from '../childRoutes';
import HomePage from './pages/HomePage';
import NuiteeSearchPage from './pages/NuiteeSearchPage';
import NuiteeDetailsPage from './pages/NuiteeDetailsPage';
import LxpDetailsPage from './pages/LxpDetailsPage';
import SpotnanaDetailsPage from './pages/SpotnanaDetailsPage';

const pageByPathname = {
  '/nuitee/search': NuiteeSearchPage,
  '/nuitee/details': NuiteeDetailsPage,
  '/lxp/details': LxpDetailsPage,
  '/spotnana/details': SpotnanaDetailsPage,
};

const TravelHotelVendorComparison = ({ languageData, locale, location = {} }) => {
  if (Object.entries(languageData).length === 0) {
    return <ProgressCircular />;
  }

  const pathname = location?.pathname || '/';
  const PageComponent = pageByPathname[pathname] || HomePage;

  return (
    <IntlProvider locale={locale} messages={languageData}>
      <Helmet
        htmlAttributes={{ lang: locale }}
        link={[
          {
            rel: 'stylesheet',
            href: 'https://www.aexp-static.com/cdaas/dls/packages/@americanexpress/dls/7.15.0/stylesheets/dls-core.min.css',
          },
          {
            rel: 'icon',
            href: 'https://www.americanexpress.com/favicon.ico',
          },
        ]}
      />
      <RenderModule moduleName="axp-global-header" />
      <Surface variant="fg-subtle">
        <main className="container-responsive pad-responsive">
          <PageComponent />
        </main>
      </Surface>
      <RenderModule moduleName="axp-footer" />
    </IntlProvider>
  );
};

export const TestableTravelHotelVendorComparison = TravelHotelVendorComparison;

TravelHotelVendorComparison.propTypes = {
  languageData: PropTypes.shape({}).isRequired, // no need to restate all the keys in the lang pack
  locale: PropTypes.string.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }),
};

// Read about childRoutes:
// https://github.com/americanexpress/one-app/blob/main/docs/api/modules/Routing.md#childroutes
TravelHotelVendorComparison.childRoutes = childRoutes;

// Read about appConfig:
// https://github.com/americanexpress/one-app/blob/main/docs/api/modules/App-Configuration.md
/* istanbul ignore next */
if (!global.BROWSER) {
  // eslint-disable-next-line n/global-require -- require needs to be inside browser check
  TravelHotelVendorComparison.appConfig = require('../appConfig').default;
}

export const loadModuleData = ({ store: { dispatch } }) => Promise.all([
  dispatch(
    loadLanguagePack('travel-hotel-vendor-comparison', {
      fallbackLocale: 'en-US',
    })
  ),
  dispatch(
    composeModules([
      { name: 'axp-global-header' },
      { name: 'axp-footer' },
    ])
  ),
]);

TravelHotelVendorComparison.holocron = {
  name: 'travel-hotel-vendor-comparison',
  loadModuleData,
};

export default oneAppModuleWrapper('travel-hotel-vendor-comparison')(
  TravelHotelVendorComparison
);
